import axios from 'axios'
import qs from 'qs'
import {
  message
} from '@/utils/resetMessage'
import store from '@/store'
import {
  getToken,
  getStroage
} from '@/utils/auth'
import Settings from '../settings'

const {
  apiDomain,
  workBenchDomain,
  locatDomain
} = Settings
var isEror=false
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

// create an axios instance
const service = axios.create({
  baseURL: apiDomain, // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (config.method === 'post') {
      if (config.content_type) {
        config.headers.post['Content-Type'] = config['content_type']
        config.data = qs.stringify(config.data)
      } else {
        config.data = {
          ...config.data
        }
      }
      if (config.content_type) {
        config.headers.post['content-type'] = config['content_type']
        config.params = JSON.stringify(config.params)
      } else {
        config.params = {
          ...config.params
          // access_token: getToken()
        }
      }
    } else {
      // console.log(config.params)
      config.params = {
        ...config.params
        // access_token: getToken()
      }
    }
    if (getStroage('token')) {
      config.headers['access_token'] =  getStroage('token')
     
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (res.code === 1007||res.code==1002) {
        window.location.href = locatDomain+'/#/login'
        return res 
    } else if(res.code!==0){
      message.error(response.data.msg)
       return res
    }else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
  }
)

export default service
